const trimIfString = (value: any) => {
    if (typeof value === "string") {
        return value?.trim();
    } else {
        return value;
    }
};

export default trimIfString;
